<template>
  <div :class="this.winWidth>1000?'home':'widths'">
    <header-content></header-content>
    <nav-head></nav-head>
    <div class="content">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <footer-content></footer-content>
  </div>
</template>
<script>
import navHead from '../components/navHead';
import headerContent from '../components/headerContent';
import footerContent from '../components/footerContent';

export default {
  components:{
    navHead,
    footerContent,
    headerContent
  },
  data() {
    return {
      winWidth:""
    };
  },
  created() {},
  mounted() {
    this.winWidth = document.body.clientWidth || document.documentElement.clientWidth;
    console.log(this.winWidth)
  },
  computed: {},
  methods: {
  }
};
</script>
 <style lang="scss">
 .home {
   position: relative;
 }
 .widths{
   width: 1404px;
 }
</style>